import axios from "axios"

export const fetchMyTickets = async () => {
    const token = JSON.parse(
        localStorage.getItem("pass_ticket_token") || "null"
    )

    const { data } = await axios.get(
        process.env.NEXT_PUBLIC_API_URL + "users/tickets",
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    )

    return data
}
